// stores/modalStore.js
import { defineStore } from 'pinia';

export const useModalStore = defineStore('modalStore', {
  state: () => ({
    show: false,
    resolve: null,  // Store the resolve function from the Promise
  }),
  actions: {
    // Method to show the modal and return a Promise
    showModal() {
      this.show = true;

      return new Promise((resolve) => {
        this.resolve = resolve;
      });
    },
    // Method to handle closing the modal and resolve the promise
    closeModal(data) {
      this.show = false;

      if (this.resolve) {
        this.resolve(data);
        this.resolve = null;  // Clear the promise reference
      }
    },
  },
});
